import { render, staticRenderFns } from "./CardMedia.vue?vue&type=template&id=2d166e90&"
import script from "./CardMedia.vue?vue&type=script&lang=js&"
export * from "./CardMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports